import { useRoutes } from 'react-router-dom';

import AuthRoutes from './AuthRoutes';
// routes
import AdminRoutes from './AdminRoutes';
import AgentRoutes from './AgentRoutes';
import CommonRoutes from './CommonRoutes';
import { useAuth } from '../hooks/useAuth';
import CustomerRoutes from './CustomerRoutes';
import FirstLoginRoutes from './FirstLoginRoutes';
import DepartmentManagerRoutes from './DepManagerRoutes';

// ==============================|| ROUTING RENDER ||============================== //
// here you can choose which routes to return according to user role && if the user is authenticated
export default function Routes() {
  const { role: userRole, firstLogin } = useAuth();
  const role = userRole?.authority;
  let routes = [AuthRoutes, CommonRoutes];
  if (firstLogin) {
    routes = [FirstLoginRoutes];
  } else {
    if (role === 'ROLE_ADMIN') {
      routes = [AdminRoutes, CommonRoutes];
    }
    if (role === 'ROLE_CUSTOMER') {
      routes = [CustomerRoutes, CommonRoutes];
    }
    if (role === 'ROLE_AGENT') {
      routes = [AgentRoutes, CommonRoutes];
    }
    if (role === 'ROLE_DEPARTMENTMANAGER') {
      routes = [DepartmentManagerRoutes, CommonRoutes];
    }
  }
  return useRoutes(routes);
}
